// Third-Party
import MenuPopover from "@components/MenuPopover";
import { Box, Stack, Typography } from "@mui/material";

// Internal
import {
  modelMenuPopoverStyle,
  getOptionRowStyle,
  optionTitleStyle,
  optionDescriptionStyle,
} from "../../styles/askDostStyles";
import { MODEL_OPTIONS } from "../../utils/constants";

// Types
import { IAskDostModelMenuProps } from "../../types";

export { MODEL_OPTIONS };

export const AskDostModelMenu = ({
  anchorEl,
  onClose,
  palette,
  translate,
  selectedModelId,
  onSelect,
}: IAskDostModelMenuProps) => {
  return (
    <MenuPopover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      disabledArrow
      sx={modelMenuPopoverStyle}
    >
      <Stack spacing={0.25}>
        {MODEL_OPTIONS.map((model) => {
          const isSelected = model.id === selectedModelId;
          return (
            <Box
              key={model.id}
              onClick={() => {
                onSelect(model.id);
                onClose();
              }}
              sx={getOptionRowStyle(palette, isSelected)}
            >
              <Typography variant="body2" sx={optionTitleStyle(palette)}>
                {translate(model.nameKey)}
              </Typography>
              <Typography variant="caption" sx={optionDescriptionStyle(palette)}>
                {translate(model.descKey)}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </MenuPopover>
  );
};

